import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function LegalLayout({ title, overline, children }) {
  return (
    <div className="bg-white" data-testid="legal-page">
      <section className="bg-ink text-white relative overflow-hidden nx-arch-skyline-dark" style={{ paddingTop: 200, paddingBottom: 120 }}>
        <div className="absolute inset-0 nx-hero-grid opacity-50"></div>
        <div className="nx-container relative">
          <Link to="/" className="inline-flex items-center gap-2 text-mist hover:text-cyan" style={{ marginBottom: 32, fontSize: 15 }}>
            <ArrowLeft size={16} strokeWidth={1.75} /> Retour à l'accueil
          </Link>
          <span className="nx-overline">{overline}</span>
          <h1 className="text-white" style={{ marginTop: 24, marginBottom: 0 }}>{title}</h1>
        </div>
      </section>
      <section className="bg-white nx-arch-grid-light" style={{ paddingTop: 120, paddingBottom: 120 }}>
        <div className="nx-container" style={{ maxWidth: 900 }}>
          {children}
        </div>
      </section>
    </div>
  );
}

const Section = ({ heading, children }) => (
  <>
    <h3 style={{ marginTop: 48, marginBottom: 24 }}>{heading}</h3>
    {children}
  </>
);

export function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" overline="Informations légales">
      <Section heading="Éditeur du site">
        <p>
          <strong style={{ color: "#0D2B45" }}>NOVANEXT SERVICES GÉNÉRAUX</strong><br />
          Siège social&nbsp;: 56 avenue Aristide Briand, 93240 Stains, France<br />
          Téléphone&nbsp;: <a href="tel:+33189628787" style={{ color: "#0099CC", fontWeight: 500 }} data-testid="legal-phone">01 89 62 87 87</a> · Email&nbsp;: <a href="mailto:contact@novanextfacility.fr" style={{ color: "#0099CC", fontWeight: 500 }} data-testid="legal-email">contact@novanextfacility.fr</a><br />
          SIREN 985 261 973 · RCS Bobigny<br />
          Directeur de la publication&nbsp;: DIARISSO Idrissa
        </p>
      </Section>
      <Section heading="Hébergement">
        <p>Ce site est hébergé sur une infrastructure sécurisée conforme aux standards européens.</p>
      </Section>
      <Section heading="Propriété intellectuelle">
        <p>L'ensemble du contenu de ce site (textes, visuels, logo, éléments graphiques) est protégé par le droit d'auteur. Toute reproduction est interdite sans autorisation préalable écrite.</p>
      </Section>
      <Section heading="Responsabilité">
        <p>NOVANEXT s'efforce d'assurer l'exactitude des informations diffusées sur ce site. Toutefois, elle ne saurait être tenue responsable des erreurs ou omissions.</p>
      </Section>
    </LegalLayout>
  );
}

export function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" overline="Données personnelles">
      <p>
        Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, NOVANEXT s'engage à protéger la confidentialité des données personnelles collectées via ce site.
      </p>
      <Section heading="Données collectées">
        <p>Nom, email, téléphone, société et message uniquement dans le cadre d'une demande de devis volontairement transmise. Aucune donnée n'est vendue ni transmise à des tiers commerciaux.</p>
      </Section>
      <Section heading="Finalité">
        <p>Traitement de votre demande, envoi d'un devis personnalisé et suivi commercial dans le cadre de notre relation contractuelle.</p>
      </Section>
      <Section heading="Vos droits">
        <p>
          Vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition à vos données. Pour l'exercer, contactez-nous à{" "}
          <a href="mailto:contact@novanextfacility.fr" style={{ color: "#0099CC", fontWeight: 500 }}>contact@novanextfacility.fr</a>.
        </p>
      </Section>
      <Section heading="Cookies">
        <p>Ce site utilise uniquement des cookies techniques nécessaires à son bon fonctionnement. Aucun cookie de traçage publicitaire n'est déposé.</p>
      </Section>
    </LegalLayout>
  );
}

export function PlanDuSite() {
  const map = [
    { title: "Accueil", to: "/" },
    { title: "Pourquoi NOVANEXT ?", to: "/pourquoi-nous" },
    { title: "Nos pôles de services", to: "/services" },
    { title: "À propos", to: "/a-propos" },
    { title: "Réalisations", to: "/realisations" },
    { title: "Questions fréquentes", to: "/faq" },
    { title: "Contact & Devis", to: "/contact" },
    { title: "Mentions légales", to: "/mentions-legales" },
    { title: "Politique de confidentialité", to: "/confidentialite" },
  ];
  return (
    <LegalLayout title="Plan du site" overline="Navigation">
      <ul style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {map.map((m) => (
          <li key={m.to}>
            <Link
              to={m.to}
              className="hover:text-cyan"
              style={{ color: "#0D2B45", fontWeight: 500, fontSize: 17, borderBottom: "1px solid transparent" }}
            >
              → {m.title}
            </Link>
          </li>
        ))}
      </ul>
    </LegalLayout>
  );
}
